export function makeNestedList(arr, id, parent_id, children_property, priority_property) {
  let array = JSON.parse(JSON.stringify(arr));
  let children = Boolean(children_property) ? children_property : 'children';
  let priority = Boolean(priority_property) ? priority_property : false;
  let i;
  for (i = 0; i < array.length; i++) {
    if (array[i][parent_id] && array[i][parent_id] !== 0) {
      array.forEach((parent) => {
        if (array[i][parent_id] == parent[id]) {
          if (!parent[children]) {
            parent[children] = [];
          }
          parent[children].push(array[i]);
          array.splice(i, 1);
          i == 0 ? i = 0 : i--;
        } else if (parent[children]) {
          findIdsOfChildren(parent);
        }
      });
    }
  }

  function findIdsOfChildren(parent) {
    parent[children].forEach((child) => {
      if (child[id] == array[i][parent_id]) {
        if (!child[children]) {
          child[children] = [];
        }
        child[children].push(array[i]);
        array.splice(i, 1);
        i == 0 ? i = 0 : i--;
      } else if (child[children]) {
        findIdsOfChildren(child);
      }
    });
  }

  function sortChildrensByPriority(unsorted_array) {
    unsorted_array.sort( (a, b) => a[priority] - b[priority])
    unsorted_array.forEach(element => {
      if(element[children]) {
        sortChildrensByPriority(element[children])
      }
    })
  }

  if(priority) {
    sortChildrensByPriority(array);
  }
  
  return array;
}